import * as React from "react";
import { SVGProps, memo } from "react";
const SvgNarrowSortArrowDescending = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 9 19"
    xmlSpace="preserve"
    role="img"
    {...props}
  >
    <path
      style={{
        fill: "#333",
      }}
      d="M5 10V5H4v5H2.5l2 3.6 2-3.6z"
    />
  </svg>
);
const Memo = memo(SvgNarrowSortArrowDescending);
export default Memo;
